/**
 * Power Input Fields - Power consumption configuration
 */

import React from 'react';
import { Box, Flex, Text, TextField, Checkbox } from '@radix-ui/themes';
import { LightningBoltIcon } from '@radix-ui/react-icons';
import { DeviceTemplate } from '../../types';

interface PowerInputFieldsProps {
  template: Partial<DeviceTemplate>;
  onChange: (updated: Partial<DeviceTemplate>) => void;
}

const PowerInputFields: React.FC<PowerInputFieldsProps> = ({ template, onChange }) => {
  const powerInput = template.powerInput;

  return (
    <Box>
      <Flex align="center" gap="2" mb="2">
        <Checkbox
          checked={!!powerInput}
          onCheckedChange={(checked) => {
            if (checked) {
              onChange({ ...template, powerInput: { voltage: 12, maxCurrent: 0 } });
            } else {
              onChange({ ...template, powerInput: undefined });
            }
          }}
        />
        <Text size="2" weight="bold">
          <LightningBoltIcon style={{ display: 'inline', verticalAlign: 'middle' }} /> Has Power Input
        </Text>
      </Flex>

      {powerInput && (
        <Box p="3" style={{ backgroundColor: 'var(--gray-2)', borderRadius: 'var(--radius-2)' }}>
          <Flex gap="2">
            <Box style={{ flex: 1 }}>
              <Text as="label" size="1">Voltage (V)</Text>
              <TextField.Root
                type="number"
                step="0.1"
                value={powerInput.voltage}
                onChange={(e) => onChange({
                  ...template,
                  powerInput: { ...powerInput, voltage: parseFloat(e.target.value) || 0 }
                })}
                mt="1"
              />
            </Box>
            <Box style={{ flex: 1 }}>
              <Text as="label" size="1">Current (A)</Text>
              <TextField.Root
                type="number"
                step="0.1"
                value={powerInput.maxCurrent}
                onChange={(e) => onChange({
                  ...template,
                  powerInput: { ...powerInput, maxCurrent: parseFloat(e.target.value) || 0 }
                })}
                mt="1"
              />
            </Box>
            <Box style={{ flex: 1 }}>
              <Text as="label" size="1">Power (W)</Text>
              <TextField.Root
                value={(powerInput.voltage * powerInput.maxCurrent).toFixed(1)}
                readOnly
                mt="1"
                style={{ backgroundColor: 'var(--gray-3)' }}
              />
            </Box>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default PowerInputFields;
